// TODO: Should match from configurator, but we cant import from there 🤔.
export enum ConfiguratorSdkEvents {
  BuildingRendered = 'idearoom/configurator-sdk-event/building-rendered',
  Connected = 'idearoom/configurator-sdk-event/connected',
  Error = 'idearoom/configurator-sdk-event/error',
  FloorplanGenerated = 'idearoom/configurator-sdk-event/floorplan-generated',
  Loaded = 'idearoom/configurator-sdk-event/loaded',
  Saved = 'idearoom/configurator-sdk-event/saved',
  ScreenshotSaved = 'idearoom/configurator-sdk-event/screenshot-saved',
  SnackbarAction = 'idearoom/configurator-sdk-event/snackbar-action',
}

export enum ConfiguratorSdkOperations {
  ChangeStructureSupplier = 'idearoom/configurator-sdk-operation/change-structure-supplier',
  ChangeStyle = 'idearoom/configurator-sdk-operation/change-style',
  CloseLocationDialog = 'idearoom/configurator-sdk-operation/close-location-dialog',
  GenerateFloorplan = 'idearoom/configurator-sdk-operation/generate-floorplan',
  Initialize = 'idearoom/configurator-sdk-operation/initialize',
  Load = 'idearoom/configurator-sdk-operation/load',
  Save = 'idearoom/configurator-sdk-operation/save',
  SaveScreenshot = 'idearoom/configurator-sdk-operation/save-screenshot',
  SaveOptionScreenshot = 'idearoom/configurator-sdk-operation/save-option-screenshot',
  Snackbar = 'idearoom/configurator-sdk-operation/snackbar',
}

export const ConnectSdkQueryParameter = 'connectsdk';
